import type { FC } from 'react';
import {
  ClockIcon,
  ExclamationCircleIcon,
  ShieldCheckIcon,
  ShieldExclamationIcon,
} from '@heroicons/react/24/outline';

import { Tooltip } from '@/components/ui/tooltip';
import { WarrantyCoverageStatus } from '@/warranty/domain/entities/warranty-status';

type WarrantyCoverageStatusIconProps = {
  status: WarrantyCoverageStatus;
};

const iconFromWarrantyCoverage: Record<WarrantyCoverageStatus, JSX.Element> = {
  [WarrantyCoverageStatus.NO_DATA]: (
    <ExclamationCircleIcon className="size-4" />
  ),
  [WarrantyCoverageStatus.VALID]: <ShieldCheckIcon className="size-4" />,
  [WarrantyCoverageStatus.EXPIRED]: <ClockIcon className="size-4" />,
  [WarrantyCoverageStatus.CASE_OPEN]: (
    <ShieldExclamationIcon className="size-4" />
  ),
};

export const WarrantyCoverageStatusIcon: FC<
  WarrantyCoverageStatusIconProps
> = ({ status }) => (
  <Tooltip
    delay
    content={
      status === WarrantyCoverageStatus.VALID
        ? 'Warranty Valid'
        : status === WarrantyCoverageStatus.EXPIRED
          ? 'Warranty Expired'
          : 'Warranty Case Open'
    }
  >
    {iconFromWarrantyCoverage[status]}
  </Tooltip>
);
